import forOwn from 'lodash/forOwn';
import invariant from 'invariant';
import { deprecated } from '@cancercentrum/inca';
import { registerDefaultMethods } from './methods';
import * as utils from './utils';
const createDefaultGetMessage = (message)=>(paramValue)=>({
            phrase: message,
            params: {
                value: paramValue
            }
        });
class Validator {
    methods = {};
    constructor(){
        registerDefaultMethods(this);
    }
    addMethod(name, validatorFunction, phraseOrGetter) {
        this.methods[name] = {
            validatorFunction: validatorFunction,
            getMessageData: typeof phraseOrGetter === 'string' ? createDefaultGetMessage(phraseOrGetter) : phraseOrGetter
        };
    }
    hasMethod(methodName) {
        return Object.prototype.hasOwnProperty.call(this.methods, methodName);
    }
    /**
     * Checks if the value is optional, e.g. not required.
     * @param value
     */ optional(value) {
        return !this.methods.required.validatorFunction.call(this, value, true);
    }
    validateRule(value, ruleName, param) {
        if (ruleName === 'messages') {
            deprecated('validation_messages', 'messages is no longer supported. Use param.message instead.');
            return;
        }
        invariant(Object.prototype.hasOwnProperty.call(param, 'value'), 'All rule objects should have a value property.');
        const rule = this.methods[ruleName];
        const paramValue = utils.unwrap(param.value);
        // Check if the rule should be run, e.g. if you have number: false, that rule should not be run.
        if (paramValue !== false && paramValue !== undefined) {
            const isValid = rule.validatorFunction.call(this, value, paramValue) !== false;
            if (!isValid) {
                const msgData = rule.getMessageData(paramValue);
                // If the message/phrase should be overriden (eg when passing a <rule>Message prop to a Question).
                if (param.message) {
                    msgData.phrase = param.message;
                }
                return {
                    rule: ruleName,
                    isFatal: param.isFatal !== false,
                    isError: param.isFatal !== false,
                    isWarning: param.isFatal === false,
                    message: msgData.phrase,
                    options: msgData.params
                };
            }
        }
    }
    validate(value, rulesToValidate) {
        // / <summary>Validates the target observable based on its rules from the extender.</summary>
        // / <param name="target">Observable to validate.</param>
        // / <returns>True if validation passed, otherwise false.</returns>
        const errors = [];
        forOwn(rulesToValidate, (v, ruleName)=>{
            const ruleData = rulesToValidate[ruleName];
            const ruleResult = this.validateRule(value, ruleName, ruleData);
            // If the rule fails validation then an error object is returned
            if (ruleResult !== undefined) {
                errors.push(ruleResult);
            }
        });
        return errors;
    }
}
export default Validator;
